export function uploadFile() {
    $('input[type="file"]').change(function (e) {
        var fileName = e.target.files[0].name;
        $(this).closest('.customInputFile__btn').find('.customInputFile__label').empty().html(fileName);
    });
}

uploadFile();
